/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { FxIdWebFeaturesInfoNewsRequestToJSON, FxIdWebFeaturesInfoNewsResponseFromJSON, } from '../models/index';
/**
 *
 */
export class InfoApi extends runtime.BaseAPI {
    /**
     */
    async fxIdWebFeaturesInfoCheckAccountExistsBySocialIdentifierEndpointRaw(requestParameters, initOverrides) {
        if (requestParameters['game'] == null) {
            throw new runtime.RequiredError('game', 'Required parameter "game" was null or undefined when calling fxIdWebFeaturesInfoCheckAccountExistsBySocialIdentifierEndpoint().');
        }
        if (requestParameters['socialIdentifierType'] == null) {
            throw new runtime.RequiredError('socialIdentifierType', 'Required parameter "socialIdentifierType" was null or undefined when calling fxIdWebFeaturesInfoCheckAccountExistsBySocialIdentifierEndpoint().');
        }
        if (requestParameters['socialIdentifier'] == null) {
            throw new runtime.RequiredError('socialIdentifier', 'Required parameter "socialIdentifier" was null or undefined when calling fxIdWebFeaturesInfoCheckAccountExistsBySocialIdentifierEndpoint().');
        }
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/api/v1/info/check_account_exists_by_social_identifier/{Game}/{SocialIdentifierType}/{SocialIdentifier}`.replace(`{${"Game"}}`, encodeURIComponent(String(requestParameters['game']))).replace(`{${"SocialIdentifierType"}}`, encodeURIComponent(String(requestParameters['socialIdentifierType']))).replace(`{${"SocialIdentifier"}}`, encodeURIComponent(String(requestParameters['socialIdentifier']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     */
    async fxIdWebFeaturesInfoCheckAccountExistsBySocialIdentifierEndpoint(game, socialIdentifierType, socialIdentifier, initOverrides) {
        await this.fxIdWebFeaturesInfoCheckAccountExistsBySocialIdentifierEndpointRaw({ game: game, socialIdentifierType: socialIdentifierType, socialIdentifier: socialIdentifier }, initOverrides);
    }
    /**
     */
    async fxIdWebFeaturesInfoNewsEndpointRaw(requestParameters, initOverrides) {
        if (requestParameters['fxIdWebFeaturesInfoNewsRequest'] == null) {
            throw new runtime.RequiredError('fxIdWebFeaturesInfoNewsRequest', 'Required parameter "fxIdWebFeaturesInfoNewsRequest" was null or undefined when calling fxIdWebFeaturesInfoNewsEndpoint().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        const response = await this.request({
            path: `/api/v1/info/news`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FxIdWebFeaturesInfoNewsRequestToJSON(requestParameters['fxIdWebFeaturesInfoNewsRequest']),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => FxIdWebFeaturesInfoNewsResponseFromJSON(jsonValue));
    }
    /**
     */
    async fxIdWebFeaturesInfoNewsEndpoint(fxIdWebFeaturesInfoNewsRequest, initOverrides) {
        const response = await this.fxIdWebFeaturesInfoNewsEndpointRaw({ fxIdWebFeaturesInfoNewsRequest: fxIdWebFeaturesInfoNewsRequest }, initOverrides);
        return await response.value();
    }
}
//# sourceMappingURL=InfoApi.js.map